import { Swords } from "lucide-react";

export const ChallengeBanner = ({ challenge }) => (
  <div
    className="floaty mb-5 rounded-[22px] bg-[#FFD166] text-[#14233D] px-4 py-3 flex items-center gap-3 shadow-[0_5px_0_#B9800E]"
    data-testid="challenge-banner"
  >
    <span className="w-9 h-9 rounded-full bg-[#EAF7FF] text-[#9A6A00] flex items-center justify-center shrink-0">
      <Swords size={18} />
    </span>
    <p className="text-[13px] font-semibold leading-snug">
      Il tuo amico è arrivato a <strong className="font-display text-[15px]">{challenge.island}</strong>
      {challenge.crewName && (
        <>
          {" "}con <strong data-testid="challenge-crew-name">«{challenge.crewName}»</strong>
        </>
      )}
      . Riesci a batterlo?
    </p>
  </div>
);
